/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.info-title[_ngcontent-%COMP%]{font-weight:600;font-size:14px}.warning[_ngcontent-%COMP%]{font-weight:600;color:red}\n/*# sourceMappingURL=toll-info.component.css.map*/"];
export { styles as styles };
